import { BaseCalendarSettings } from '../../standalone-app/event-calendar/models';

export enum BlockType {
	TcsmResourceBlock = 'TcsmResourceBlock',
	TcsmActionBlock = 'TcsmActionBlock',
	TcsmNewsUpdateBlock = 'TCSMNewsUpdateBlock',
	TcsmLinkBlock = 'TCSMLinkBlock',
	TcsmVideoBlock = 'TcsmVideoBlock',
	TcsmDatesBlock = 'TcsmDatesBlock',
	TcsmParagraphBlock = 'TcsmParagraphBlock',
	TcsmInformationBlock = 'TcsmInformationBlock',
	TcsmButtonBlock = 'TcsmButtonBlock',
	TcsmAnnualEnrollmentMessageBlock = 'TcsmAnnualEnrollmentMessageBlock',
	RedesignCalendarWidgetBlock = 'RedesignCalendarWidgetBlock',
	RedesignCalloutBlock = 'RedesignCalloutBlock',
	RedesignRelatedLinksBlock = 'RedesignRelatedLinksBlock',
	RedesignAnnouncementBlock = 'RedesignAnnouncementBlock',
	ContentRecommendationsBlock = 'ContentRecommendationsBlock',
}

export enum AlignmentType {
	Right = 'Right',
	Left = 'Left',
	Center = 'Center',
}

export interface BaseBlockModel {
	blockType: string | BlockType;
}

export interface TcsmActionLink {
	linkText: string;
	linkUrl: string;
	externalLinkUrl: any;
	friendlyUrl: string;
	newWindow: boolean;
	rolesMatch: string;
}

export interface TcsmContentLink extends TcsmActionLink {
	// url: string,
	reactLink: boolean,
	isPdf: boolean,
	addAsterisk: boolean,
}
export type TcsmLinkBlock = BaseBlockModel & TcsmContentLink;

export interface TcsmResourceBlock extends BaseBlockModel {
	image: string;
	imageAltText: string;
	title: string;
	subtitle: string;
	description: string;
	links: TcsmContentLink[];
	viewAllText: string;
	viewAllLinkUrl: string;
}

export interface TcsmActionBlock extends BaseBlockModel {
	title: string;
	description: string;
	links: TcsmActionLink[];
}

export interface TcsmNewsUpdateBlock extends BaseBlockModel {
	date: string;
	title: string;
	summary: string;
	itemLink: TcsmLinkBlock;
	thumbnailImage: string;
	thumbnailImageAltText: string;
}

export interface RedesignAnnouncementBlock extends BaseBlockModel {
	announcementId: number;
	eyebrowText: string;
	title: string;
	date: string;
	description: string;
	ctaText: string;
	ctaLink: string;
	image: string;
	imageAltText: string;
}

export interface TcsmVideoBlock extends BaseBlockModel {
	pageTitle: string;
	captionWysiwyg: string;
	thumbnail: string;
	hidePlayIcon: boolean;
	videoUrl: string;
	videoContentType: string;
	vimeoId: string;
	youTubeId: string;
}

export interface TcsmDatesBlock extends BaseBlockModel {
	pageTitle: string;
	description: string;
	pageSmallTitle: string;
	dateList: DateItem[];
}

export interface DateItem {
	fullDate: string;
	month: string;
	day: string;
	description: string;
}

export interface TcsmParagraphBlock extends BaseBlockModel {
	title: string;
	content: string;
}

export interface TcsmInformationBlock extends BaseBlockModel {
	content: string;
}

export interface TcsmButtonBlock extends BaseBlockModel {
	linkText: string;
	linkUrl: string;
	alignment: AlignmentType;
}

export interface TCSMAnnualEnrollmentMessage {
	annualEnrollmentStatus: string;
	message: string;
}

export interface TcsmAnnualEnrollmentMessageBlock extends BaseBlockModel {
	messages: TCSMAnnualEnrollmentMessage[];
}

export interface RedesignRelatedLink {
	title: string;
	friendlyUrl: string;
}

export interface RedesignCalloutBlock extends BaseBlockModel {
	alignment: string;
	pretitle: string;
	title: string;
	titleLink: string;
	summary: string;
	ctaText: string;
	ctaLink: string;
	thumbnail: string;
	thumbnailAltText: string;
	thumbnailLink: string;
	youtubeID: string;
	youtubeAutoPlay: boolean;
	vimeoID: string;
	videoReference: string;
	relatedLinks: RedesignRelatedLink[];
}

export interface RedesignCalendarWidgetBlockModel extends BaseBlockModel {
	widgetSettings: BaseCalendarSettings;
}


export interface RedesignRelatedLinkCard {
	categoryName: string;
	categoryUrl: string;
	articleTitle: string;
	subtitle: string;
	summaryDescription: string;
	isVideo: boolean;
	videoEmbedUrl: string;
	thumbnailUrl: string;
	thumbnailAltText: string;
	linkUrl: string;
	linkIcon: string;
}

// Widget settings for one Optimizely Content Recommendations placement
// (RedesignRelatedLinkRecommendation on the server).
export interface ContentRecommendationsSettings {
	deliveryApiKey: string;
	numberOfRecommendations: number;
	recommendationsTemplate: string;
}

// One carousel slide, in CMS ContentArea order; exactly one of card/recommendation is set.
export interface RedesignRelatedLinkSlide {
	card?: RedesignRelatedLinkCard;
	recommendation?: ContentRecommendationsSettings;
}

export interface RedesignRelatedLinksBlock extends BaseBlockModel {
	title: string;
	relatedItemData: RedesignRelatedLinkSlide[];
}


// Optimizely Content Recommendations (idio) block; recommendations are fetched
// client-side from the delivery API and rendered with the mustache template
// authored on the CMS block (same template the MVC widget uses).
export interface ContentRecommendationsBlockModel extends BaseBlockModel {
	deliveryApiKey: string;
	numberOfRecommendations: number;
	recommendationsTemplate: string;
}